// Account Entitlements Flow Utilities
import { getSelfcareUrl } from "../config/config";

// Helper function to construct selfcare URL with from venue ID query param
export const getAccountEntitlementsSelfcareUrl = (venueId) => {
  const baseUrl = getSelfcareUrl(window.location.host);
  
  if (venueId && venueId.trim() !== 'undefined' && venueId.trim() !== '') {
    return `${baseUrl}?from=${venueId.toLowerCase()}`;
  }
  
  // Fallback: try to get nas_identifier from query string and parse venue
  const urlParams = new URLSearchParams(window.location.search);
  const nasIdentifier = urlParams.get('nas_identifier');
  
  if (nasIdentifier) {
    // Parse venue from nas_identifier (e.g., "ccg_mcblaz-via1" -> "mcblaz")
    const venueMatch = nasIdentifier.match(/_([^-]+)/);
    const parsedVenue = venueMatch ? venueMatch[1] : nasIdentifier;
    return `${baseUrl}?from=${parsedVenue.toLowerCase()}`;
  }
  
  // No venue information available - return base URL without from parameter
  // Users will be prompted to select their venue in selfcare
  return baseUrl;
};